<template>
   <svg width="18" height="17" viewBox="0 0 23 18" fill="none" aria-hidden="true" focusable="false">
      <rect x="0.831543" y="0.742676" width="22.1133" height="17.0074" rx="2" fill="#FFF5F3" />
      <path
         d="M22.7405 1.27846C22.3071 0.690808 21.4794 0.565729 20.8918 0.999089L11.9682 7.5797L2.94624 1.07086C2.35355 0.643271 1.52645 0.777109 1.09886 1.3698C0.671678 1.96192 0.804797 2.78814 1.39633 3.21613L11.961 10.8598L11.9611 10.8576L11.9615 10.8622L22.4606 3.12754C23.0486 2.69431 23.174 1.86631 22.7405 1.27846Z"
         fill="#D93025"
      />
      <path d="M20.3552 2.11976H23V15.7129C23 16.8175 22.1046 17.7129 21 17.7129H20.3552V2.11976Z" fill="#D93025" />
      <path
         d="M3.49462 2.15651H0.849844V15.7497C0.849844 16.8542 1.74527 17.7497 2.84984 17.7497H3.49462V2.15651Z"
         fill="#D93025"
      />
   </svg>
</template>
